import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Button from '/imports/ui/components/common/button/component';
import SvgIcon from '/imports/ui/components/common/icon-svg/component';
import { isDesktop } from '../../layout/utils';

const CalculatorWrapper = styled.div`
  position: relative;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: ${props => props.width}px;
  height: ${props => props.height + 60}px;
  ${'' /* min-width: 600px;
  min-height: 400px;
  max-width: 1400px;
  max-height: 1000px; */}
  min-width: ${props => (!isDesktop() ? 400 : 600)}px;
  min-height: ${props => (!isDesktop()  ? 300 : 400)}px;
  max-width: ${props => (!isDesktop()  ? 800 : 1400)}px;
  max-height: ${props => (!isDesktop()  ? 600 : 1000)}px;


  .avNameLogo {
    display: none !important;
  }
`;

const CalculatorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
  border-radius: 4px 4px 0 0;
  cursor: move;
  user-select: none;
`;

const CalculatorTitle = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  .title-text{
    margin-left: 4px;
  }

  .light-text {
    color: var(--color-gray-light, #999);
    font-weight: 400;
    margin-left: 4px;
    font-size: 12px;
  }

  .light-text svg {
    width: 13px;
    height: 13px;
    opacity: 0.6;
  }
`;

const CloseButton = styled(Button)`
  && {
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.2s;
  }
`;

const CalculatorContent = styled.div`
  ${'' /* padding: 15px; */}
  height: calc(100% - 58px);
  overflow: hidden;
  position: relative;
`;

const ResizeHandle = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: se-resize;
  background: linear-gradient(135deg, transparent 0%, transparent 50%, #ccc 50%, #ccc 100%);
  border-radius: 0 0 4px 0;
  
  &:hover {
    background: linear-gradient(135deg, transparent 0%, transparent 50%, #999 50%, #999 100%);
  }
`;

const CalculatorBottomHandle = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0px;
  height: 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #eee;
  border-radius: 0 0 0 4px;
  cursor: move;
  user-select: none;
  
  &:hover {
    background-color: #e9ecef;
  }
`;
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #f8f9fa;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e3e3e3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.div`
  color: #666;
  font-size: 14px;
  text-align: center;
`;
const GeoGebraContainer = ({ pluginsExtensibleAreasAggregatedState, setPluginsExtensibleAreasAggregatedState }) => {
  const ggbContainerRef = useRef(null);

  const isDesktop_ = isDesktop()
  const [size, setSize] = useState(!isDesktop_ ? { width: 500, height: 400 } : { width: 800, height: 600 });
  const [isResizing, setIsResizing] = useState(false);
  const [applet, setApplet] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const closeFloatingWindow = () => {
    const updatedFloatingWindows = pluginsExtensibleAreasAggregatedState?.floatingWindows?.filter(
      (win) => win.id !== 'geogebra-graphing-calc'
    ) || [];

    setPluginsExtensibleAreasAggregatedState(updatedFloatingWindows);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsResizing(true);

    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = size.width;
    const startHeight = size.height;

    const handleMouseMove = (e) => {
      const deltaX = e.clientX - startX;
      const deltaY = e.clientY - startY;
      // ⬅️ Tighter constraints on iPad
      const minW = !isDesktop_ ? 400 : 700;
      const minH = !isDesktop_ ? 300 : 500;
      const maxW = !isDesktop_ ? 800 : 1400;
      const maxH = !isDesktop_ ? 600 : 1000;

      const newWidth = Math.max(minW, Math.min(maxW, startWidth + deltaX));
      const newHeight = Math.max(minH, Math.min(maxH, startHeight + deltaY));
      // const newWidth = Math.max(700, Math.min(1400, startWidth + deltaX));
      // const newHeight = Math.max(500, Math.min(1000, startHeight + deltaY));

      setSize({ width: newWidth, height: newHeight });
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);

      // Update GeoGebra applet size after resize stops
      setTimeout(() => {
        if (applet && applet.setSize) {
          applet.setSize(size.width, size.height);
          applet.refreshViews?.();
          applet.repaint?.();
        }
      }, 100);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  useEffect(() => {
    // Function to load the deployggb script
    const loadScript = () => {
      setIsLoading(true)
      const script = document.createElement('script');
      script.src = 'https://www.geogebra.org/scripts/deployggb.js';
      script.async = true;
      script.onload = () => {
        const params = {
          id: "ggbApplet",
          appName: "graphing",
          width: size.width,
          height: size.height,
          showToolBar: true,
          showAlgebraInput: true,
          showMenuBar: true,
        };
        const newApplet = new window.GGBApplet(params, true);
        newApplet.inject(ggbContainerRef.current);
        setApplet(newApplet);
      };
      document.body.appendChild(script);
    };

    if (!window.GGBApplet) {
      loadScript();
      setTimeout(() => setIsLoading(false), 1000);
    } else {
      // If already loaded
      const params = {
        id: "ggbApplet",
        appName: "graphing",
        width: size.width,
        height: size.height,
        showToolBar: true,
        showAlgebraInput: true,
        showMenuBar: true,
      };
      const newApplet = new window.GGBApplet(params, true);
      newApplet.inject(ggbContainerRef.current);
      setApplet(newApplet);
    }
  }, []);

  useEffect(() => {
    if (window.ggbApplet?.setSize) {
      window.ggbApplet.setSize(size.width, size.height);
    }
  }, [size]);
  return (
    <CalculatorWrapper width={size.width} height={size.height}>
      <CalculatorHeader className="floating-window-handle">
        <CalculatorTitle>
          <SvgIcon iconName="graphingcalc" /> <span className='title-text'>Graphing Calculator</span>  <span className="light-text"><SvgIcon iconName="incognito" /> VISIBLE ONLY TO YOU</span>
        </CalculatorTitle>
        <CloseButton
          icon="close"
          color="default"
          size="sm"
          hideLabel
          onClick={closeFloatingWindow}
          onTouchStart={(e) => {
            e.preventDefault(); // prevents ghost click
            closeFloatingWindow();
          }}
          aria-label="Close Graphing Calculator"
        />
      </CalculatorHeader>
      <CalculatorContent>
        {isLoading && (
          <LoadingContainer>
            <Spinner />
            <LoadingText>Loading Graphing Calculator...</LoadingText>
          </LoadingContainer>
        )}
        <div ref={ggbContainerRef} id="ggb-container" style={{ width: '100%', height: '100%' }} />
      </CalculatorContent>
      <CalculatorBottomHandle className="floating-window-handle" />
      <ResizeHandle onMouseDown={handleMouseDown} />
    </CalculatorWrapper>
  );
};

export default GeoGebraContainer;
